import React from 'react';
import PropTypes from 'prop-types';
import { colors } from 'Theme';

const DealersIcon = ({ color, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="icon/fi-torsos-all"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        transform="translate(1.000000, 4.000000)"
        fill={color}
        fillRule="nonzero"
        id="Combined-Shape"
      >
        <path d="M22.3644356,9.64348515 C22.604198,9.75968317 22.7607921,10.030099 22.7607921,10.3347327 L22.7607921,13.4010297 C22.7607921,13.8118812 22.4744554,14.1447921 22.1206337,14.1447921 L19.471604,14.1447921 L19.471604,10.9273663 C19.471604,10.1047129 19.0186931,9.35477228 18.3184158,9.01568317 L15.8409505,7.83445545 L15.8433267,7.83374257 C15.5940392,7.6812438 15.3690402,7.49220941 15.1758416,7.2729505 C15.7494653,6.38209901 16.0847525,5.30447525 16.0847525,4.16815842 C16.0855354,3.43630497 15.9484105,2.71085722 15.6805545,2.02978218 C16.1130297,1.72443564 16.6153663,1.53885149 17.1592871,1.53885149 C18.742099,1.53885149 20.0245545,3.03112871 20.0245545,4.87366337 C20.0245545,6.14209901 19.4152871,7.24538614 18.518495,7.80926733 L22.3644356,9.64348515 Z M7.02582178,7.8 L4.43310891,9.00712871 C3.7190495,9.34170297 3.25853465,10.0947327 3.25853465,10.9271287 L3.25853465,14.1445545 L0.691009901,14.1445545 C0.338138614,14.1445545 0.0508514851,13.8116436 0.0508514851,13.4007921 L0.0508514851,10.3347327 C0.0508514851,10.0291485 0.21029703,9.75588119 0.452673267,9.64205941 L4.33758416,7.83374257 C3.41726733,7.27841584 2.78732673,6.16277228 2.78732673,4.87366337 C2.78732673,3.03112871 4.06954455,1.53885149 5.65354455,1.53885149 C6.17037624,1.53885149 6.64871287,1.71065347 7.06693069,1.98914851 C6.79817822,2.65449505 6.64467327,3.39089109 6.64467327,4.16815842 C6.64467327,5.33156436 6.99112871,6.42938614 7.58851485,7.32784158 C7.42151757,7.50822775 7.23246545,7.66686228 7.02582178,7.8 Z M17.8075248,10.0719208 C18.1045545,10.2154455 18.2984554,10.5507327 18.298218,10.9271287 L18.298218,14.7219802 C18.298218,15.230495 17.9436832,15.6427723 17.5062178,15.6427723 L5.22320792,15.6427723 C4.78574257,15.6427723 4.43120792,15.230495 4.43120792,14.7219802 L4.43120792,10.9271287 C4.43120792,10.5493069 4.62843564,10.2106931 4.92831683,10.0702574 L8.38194059,8.4620198 L9.73687129,7.83136634 C9.12522772,7.46281188 8.62265347,6.88966337 8.28356436,6.19461386 C7.99033663,5.59556436 7.81758416,4.90669307 7.81758416,4.16792079 C7.81758416,3.74257426 7.88863366,3.3409901 7.99176238,2.95485149 C8.43849505,1.27128713 9.77108911,0.0401584158 11.3650693,0.0401584158 C12.9894653,0.0401584158 14.3427327,1.31667327 14.7635644,3.04966337 C14.8498218,3.40728713 14.911604,3.77774257 14.911604,4.16792079 C14.9116043,4.83031515 14.7698987,5.48504502 14.496,6.08815842 C14.167604,6.81172277 13.6659802,7.41243564 13.0481584,7.80142574 L14.462495,8.47627723 L17.8075248,10.0719208 Z" />
      </g>
    </g>
  </svg>
);

DealersIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string
};

DealersIcon.defaultProps = {
  color: colors.gray.darkest,
  size: '24px'
};

export default DealersIcon;
